import { Avatar, Paper, Stack } from '@mui/material';
import { File } from 'Images';
import { Actions } from './Actions';
import { Information } from './Information';
import { useIsDesktop } from 'Hooks';
import { IFile } from 'API';
import { mandatoryFilesCategoryId } from '../FilesSection';

interface FileDocumentProps {
  file: IFile;
  onFileUpdate: () => void;
  isChecked: boolean;
  onCheckboxChange: (fileId: number, checked: boolean) => void;
}

export const FileDocument = ({
  file,
  onFileUpdate,
  isChecked,
  onCheckboxChange,
}: FileDocumentProps) => {
  const isDesktop = useIsDesktop();
  const isError =
    mandatoryFilesCategoryId.includes(file.fileCategoryRelationId) &&
    (file.isAnalysisOccured === false || file.isAnalysisSucceeded === false);
  return (
    <Paper
      sx={{
        p: isDesktop ? '20px 0 20px 32px' : '20px 8px 10px 16px',
        display: 'flex',
        flexFlow: isDesktop ? 'row' : 'column',
        alignItems: isDesktop ? 'center' : 'left',
        justifyContent: 'space-around',
        border: isError ? '1px solid #A30F28' : '1px solid #E6E8EA',
        borderRadius: '16px',
        boxShadow: '0px 4px 16px 0px #2D70D914',
      }}
    >
      {isDesktop && (
        <Avatar
          alt=''
          src={File}
          sx={{ width: '40px', height: '40px', alignSelf: 'start', mr: 1 }}
        />
      )}
      <Stack>
        <Information
          file={file}
          isChecked={isChecked}
          onCheckboxChange={onCheckboxChange}
        />
        <Actions file={file} onFileUpdate={onFileUpdate} />
      </Stack>
    </Paper>
  );
};
